import styles from "./Divider.module.scss";
import { match } from "@utils/renderPropsComposer";
import cx from "classnames";

const View = ({
  className,
  vertical = false,
  label,
  type = "default",
  color = "",
  opacity = 100,
  labelProps = {},
  light = false,
}: any) => {
  return (
    <div
      className={cx(
        "py-5 text-black-1",
        styles.divider,
        match({
          isTrue: type === "dark",
          value: {
            [styles.dark]: true,
          },
        }),
        { [styles.dividerHorizontal]: vertical },

        className
      )}
    >
      {!!label && (
        <span
          className={cx(
            "flex-shrink mx-4 flex items-center",
            styles.label,
            labelProps.className,
            {
              ["text-black-1"]: light,
              ["text-white-1"]: !light,
            }
          )}
        >
          {label}
        </span>
      )}
    </div>
  );
};
export default View;
